import { Action } from 'redux'
import { RelatedType } from '../../type/NotificationType'

export type CustomerNotificationStateType = {
    successDataExecuted: {
        customerId: number
        relatedType: RelatedType
        relatedId: number
        isEnableNotification: boolean
    } | null
}
export interface CustomerNotificationActions<T = any> extends Action {
    payload?: T
}

export const CustomerNotificationActionTypes = {
    toggleNotification: 'CUSTOMER_NOTIFICATION_TOGGLE',
    setSuccessDataExecuted: 'SET_SUCCESS_DATA_EXECUTED',
}
